// ManualNameStep.tsx — step 'manual-name' del onboarding (vía manual).
// Qué hace: pide el nombre de marca a mano y pasa al step de logo manual.
// Qué exporta: ManualNameStep.
// Quién lo usa: CreateWorkspaceModal.

import { Button } from '../../Button';
import { Input, InputWrapper } from '../../Input';
import { WizardStep } from '../types';

interface Props {
  manualName: string;
  setManualName: (v: string) => void;
  setBrandName: (v: string) => void;
  user: (text: string) => void;
  novah: (text: string) => void;
  pushStep: (next: WizardStep) => void;
}

export function ManualNameStep({
  manualName, setManualName, setBrandName, user, novah, pushStep,
}: Props) {
  return (
    <>
      <InputWrapper style={{ marginBottom: 8 }}>
        <Input
          value={manualName}
          onChange={e => setManualName(e.target.value)}
          placeholder="e.g., Acme Corp"
          autoFocus
        />
      </InputWrapper>
      <Button type="button" onClick={() => {
        if (!manualName.trim()) return;
        user(`Brand name: ${manualName.trim()}`);
        setBrandName(manualName.trim());
        novah("Got it! Now, do you have a logo? You can upload a file, paste a URL, or skip for now.");
        pushStep('manual-logo');
      }} disabled={!manualName.trim()} style={{ width: '100%' }}>
        Continue
      </Button>
    </>
  );
}
